// 导航菜单
export default [{
  menuName: '智慧物管',
  title: '通知公告',
  icon: 'xqgg',
  path: '/notice/noticeType'
}, {
  menuName: '智慧物管',
  title: '资源管理',
  icon: 'zygl',
  path: '/baseInformation/WuyeZiyuanManager'
}, {
  menuName: '智慧物管',
  title: '收费管理',
  icon: 'rcsf',
  path: '/frontDeskCharge/dailyCharge'
}, // {menuName: '客户服务', title: '报修管理', icon: 'bxgl2', path: '/customerService/repairManagement'},
{
  menuName: '智慧物管',
  title: '合同管理',
  icon: 'htgl2',
  path: '/leaseContract/contractList'
}, {
  menuName: '智慧物管',
  title: '工单管理',
  icon: 'gdgl',
  path: '/taskManagement/initiateRepair'
}, {
  menuName: '智慧物管',
  title: '仓库管理',
  icon: 'ckgl',
  path: '/materiel/warehouseManager'
}, {
  menuName: '智慧物管',
  title: '保洁管理',
  icon: 'bjgl',
  path: '/cleanManager/cleanArea'
}, {
  menuName: '智慧物管',
  title: '绿化管理',
  icon: 'lhgl',
  path: '/greenManager/greenArea'
}, {
  menuName: '智慧物管',
  title: '停车管理',
  icon: 'tcgl',
  path: '/parkingManagement/parkingManage'
}, // {menuName: '系统管理', title: '支付管理', icon: 'zfgl', path: '/system/payManagement'},
{
  menuName: '智慧物管',
  title: '门禁管理',
  icon: 'mjgl',
  path: '/porisAccessRecord/porisAccessRecord'
}];